<template>
  <div class=" is-fullwidth">
    <div class="card">
          <div class="card-content">
                <div class="field">
                    <label class="label">PO Number</label>
                    <div class="control">
                        <input class="input" type="text" v-model="ponumber" ref="ponumber" autofocus @keydown.enter="viewOrder()">
                    </div>
                </div>

                <div class="field ">
                    <div class="control">
                        <button class="button is-success" @click="viewOrder()" >Search</button>
                    </div>
                    
                </div>
            </div>
    </div>
    <br /> 

    <div class="notification is-info" v-if="(order.orderID == 0 || order == '')  && loading == false">
        Enter a PO Number above to search for an order
    </div>
    
    <div class="notification is-warning" v-if="loading == true">
        Seaching for your order ...
    </div>

    <div v-if="order.orderID > 0 && loading == false">
        

        <div class="card ">
            <div class="tabs mb-0">
            <ul>
                <li :class="{'is-active': tabToShow =='general'}" @click="tabToShow='general'"><a>General</a></li>
                <li :class="{'is-active': tabToShow =='customer'}" @click="tabToShow='customer'"><a>Customer</a></li>
                <li :class="{'is-active': tabToShow =='printing'}" @click="tabToShow='printing'" v-if="order.fully_printed == 1"><a>Printing/Cutting</a></li>
                <li :class="{'is-active': tabToShow =='makeup'}" @click="tabToShow='makeup'" v-if="order.fully_printed == 1"><a>Makeup</a></li>
                <li :class="{'is-active': tabToShow =='logs'}" @click="tabToShow='logs'"><a>Logs</a></li>
                <li :class="{'is-active': tabToShow =='embroidery'}" @click="tabToShow='embroidery'" v-if="order.order_embroidery==1"><a>Embroidery</a></li>
                <li :class="{'is-active': tabToShow =='extras'}" @click="tabToShow='extras'" v-if="task_allowed('knitted_trims_admin')"><a>Extras</a></li>
                <li STYLE="display:none">
                    <img src="@/assets/images/ireland.png" alt="Allocated to Ireland" style="height:30px;padding:4px 0px 0px 10px" v-if="order.ireland==1">
                    <img src="@/assets/images/offshore.png" alt="Allocated to Offshore" style="height:30px;padding:4px 0px 0px 10px" v-if="order.offshore==1">
                </li>
            </ul>
        </div>

          
            <div class="card-content" v-if="tabToShow == 'general'">
                <div class="columns">
                    <div class="column">
                    <div class="field">
                        <div class="field">
                            <label class="label">Status</label>
                            <div class="control" v-if="order.fully_printed == 1">
                                <button class="is-danger button " v-if="order.status == 'CANCELLED'">Cancelled</button>
                                <button class="is-success button " v-if="order.completed == 1">Complete</button>
                                <button class="is-info button " v-if="order.completed == 0 && order.ready_for_makeup == 1">In Makeup</button>
                                <button class="is-warning button " v-if="order.completed == 0 && order.ready_for_makeup == 0 && order.digital_print_cutting == 1">Cutting Complete</button>
                                <button class="is-primary button " v-if="order.completed == 0 && order.ready_for_makeup == 0 && order.artwork_completed == 1 && order.digital_print_cutting == 0">Ready for Print/Cut</button>
                                <button class="is-primary button " v-if="order.completed == 0 && order.ready_for_makeup == 0 && order.artwork_completed == 0">Waiting on Artwork</button>
                            </div>
                            <div class="control" v-if="order.fully_printed == 0">
                                <button class="is-danger button " v-if="order.status == 'CANCELLED'">Cancelled</button>
                                <button class="is-success button " v-if="order.completed == 1">Complete</button>
                                <button class="is-info button " v-if="order.completed == 0 ">{{ order.status }}</button>
                                
                            </div>
                        </div>
                        
                        <label class="label">PO Number</label>
                            <div class="columns">
                                <div class="control column">
                                    <input class="input" type="text" v-model="order.ponumber" readonly disabled>
                                </div>
                                <div class=" column">
                                    <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-warning">Print Order as PDF</button></a>
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Garment</label>
                            <div class="control">
                                <input class="input" type="text" v-model="order.garmentname" readonly disabled>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Required Delivery Date</label>
                            <div class="control">
                                <input class="input" type="text" v-model="order.deliverydate" readonly disabled>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Quantities</label>
                            <div class="control ">
                                <div class="columns" v-for="row in qty_sizes" :key="row.id" >
                                    <div class="column is-one-third pb-0">{{ row.name }}</div>
                                    <div class="column is-two-thirds pb-0">{{ order[row.database_name] + order[row.database_name + '_GK']}}</div>
                                </div>
                                <div class="columns"  >
                                    <div class="column is-one-third pb-0"><strong>Total</strong></div>
                                    <div class="column is-two-thirds pb-0"><strong>{{ total_qty }}</strong></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="order.completed==0 && task_allowed('complete_order')" class="mt-6" >
                            <button type="button" class="button is-danger" @click="completeOrder()">COMPLETE ORDER</button>
                        </div>

                        
                    </div>
                    <div class="column">
                        <img :src="ASP_URL + '/images/historical/' + order.garmentimage" />
                    </div>

                </div>
            </div>

            <div class="card-content" v-if="tabToShow == 'customer'">
                
                <div class="field">
                    <label class="label">Account Name</label>
                       <div class="control ">
                            <input class="input" type="text" v-model="order.clientname" readonly disabled>
                        </div>
                        
                </div>
                <div class="field">
                    <label class="label">Account Number</label>
                       <div class="control ">
                            <input class="input" type="text" v-model="order.accountnumber" readonly disabled>
                        </div>
                        
                </div>
                <div class="field">
                    <label class="label">Contact Name</label>
                       <div class="control ">
                            <input class="input" type="text" v-model="order.contactname" readonly disabled>
                        </div>
                        
                </div>
                <div class="field">
                    <label class="label">Contact Telephone</label>
                       <div class="control ">
                            <input class="input" type="text" v-model="order.telephone" readonly disabled>
                        </div>
                        
                </div>
                        
                    
            </div>

            <div class="card-content" v-if="tabToShow == 'printing'">
                     <div class="field">
                        <label class="label">Digital Print Locations</label>
                        <div class="control">
                            
                        </div>
                    </div>
                    <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Paper Print Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small is-link"  :disabled="working==true" v-for="row in locations" :key="row.id" v-show="order.print_location_id==row.id" >{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Fabric Rolls Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small is-link"  :disabled="working==true" v-for="row in locations" :key="row.id" v-show="order.fabric_print_location_id==row.id">{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Gerber Cutting Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small is-link"  :disabled="working==true" v-for="row in locations" :key="row.id" v-show="order.gerber_print_location_id==row.id">{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div class="field">
                        
                        <div class="control content">
                            <p v-if="order.artwork_printed_paper == 1" class="has-text-success">Printing on paper complete</p>
                            <p v-if="order.artwork_printed_paper == 0" class="has-text-danger">Printing on paper not complete</p>
                            <ul v-if="order.printing_papers.length > 0" class="">
                                <li v-for="row in order.printing_papers" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                            </ul>
                            <p v-if="order.artwork_printed_rolls == 1" class="has-text-success">Transmatic process complete</p><p v-if="order.artwork_printed_rolls == 0" class="has-text-danger">Transmatic process not complete</p>
                            <ul v-if="order.printing_rolls.length > 0" class="">
                                <li v-for="row in order.printing_rolls" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                            </ul>
                            <p v-if="order.digital_print_cutting == 1" class="has-text-success">Gerber cutting complete</p><p v-if="order.digital_print_cutting == 0" class="has-text-danger">Gerber cutting not complete</p>
                            <ul v-if="order.cuttings.length > 0" class="">
                                <li v-for="row in order.cuttings" :key="row.id">{{ row.date}} - {{ row.qty}} x {{ row.size_name }} - {{ row.user_forename}} {{ row.user_surname}} - {{ row.machine_name}}</li>
                            </ul>
                            <p v-if="order.ready_for_makeup == 1" class="has-text-success">Assigned for makeup</p><p v-if="order.ready_for_makeup == 0" class="has-text-danger">Not yet Processed for makeup</p>
                        </div>
                    </div>
                    

                    
                   
                </div>

                <div class="card-content" v-if="tabToShow == 'makeup'">
                    <div class="field">
                        <label class="label">Makeup Location</label>
                        <div class="control">
                            <button class="button is-success" v-if="order.makeup_location_id > 0">{{ order.makeup_location_name }}</button>
                        </div>
                    </div>

                    <OrderBundles :bundles="this.order.bundles" />
                </div>

                <div class="card-content" v-if="tabToShow=='logs'">
                    <table class="table is-fullwidth" v-if="order.logs.length > 0">
                        <thead>
                            <tr>
                                    <th>Action</th>
                                    <th>User (Who Peformed the Action)</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in order.logs" :key="row.id">
                                    <td>{{ row.text }}</td>
                                    <td>{{ row.firstname }} {{row.surname}}</td>
                                    <td>{{ row.date }}</td>
                                </tr>
                            </tbody>
                        </table>
                        
                </div>

                <div class="card-content" v-if="tabToShow=='embroidery'">
                    <h3 class="title">Design</h3>
                    <table class="table is-fullwidth is-size-7" v-if="embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.design_trex_codes.length > 0">
                        <tr>
                            <th>Trex Code</th>
                            <th>Position</th>
                            <th>Size</th>
                            <th>Stitches</th>
                            <th>Added By</th>
                            <th>Updated At</th>
                        </tr>

                        <tr v-for="row in embroidery_order.design_trex_codes" :key="row.id">
                            <td>{{ row.name }} 
                                <span class="tag is-success" v-if="row.badge==1">Badge</span> 
                                <span class="tag is-warning" v-if="row.branding==1">Branding</span> 
                                <span class="tag is-danger" v-if="row.not_approved==1">NOT Approved</span>
                            </td>
                            <td>{{ row.position }}</td>
                            <td>{{ row.size_name }}</td>
                            <td>{{ row.num_stitches}}</td>
                            <td >{{ row.firstname}} {{ row.surname}}</td>
                            <td>{{  row.updated_at_date }}</td>
                        </tr>

                    </table>
                    <div class="notification is-warning" v-if="this.embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.design_trex_codes.length == 0">
                        There are no trex codes linked to this design yet
                    </div>

                    <h3 class="title">Order</h3>
                    <table class="table is-fullwidth is-size-7" v-if="this.embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.order_trex_codes.length > 0">
                        <tr>
                            <th>Trex Code</th>
                            <th>Position</th>
                            <th>Size</th>
                            <th>Stitches</th>
                            <th>Added By</th>
                            <th>Updated At</th>
                        </tr>
                        <tr v-for="row in embroidery_order.order_trex_codes" :key="row.id">
                            <td :title="'Added/Updated on ' + row.updated_at_date ">{{ row.name }} 
                                <span class="tag is-success" v-if="row.badge==1">Badge</span> 
                                <span class="tag is-warning" v-if="row.branding==1">Branding</span> 
                                <span class="tag is-danger" v-if="row.not_approved==1">NOT Approved</span>
                            </td>
                            <td>{{ row.position }}</td>
                            <td>{{ row.size_name }}</td>
                            <td>{{ row.num_stitches}}</td>
                            <td >{{ row.firstname}} {{ row.surname}}</td>
                            <td>{{  row.updated_at_date }}</td>
                        </tr>
                    </table>
                    <div class="notification is-warning" v-if="this.embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.order_trex_codes.length == 0">
                        There are no trex codes linked to this order yet
                    </div>

                    <h3 class="title">Initials For Order</h3>
                    <table class="table is-fullwidth is-size-7" v-if="this.embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.order_initials.length > 0">
                        <tr>
                            <th>Garments</th>
                            <th>Position</th>
                            <th>Stitch Count</th>
                            <th >Total Stitches</th>
                            <th>Added By</th>
                            <th>Updated At</th>
                        </tr>
                        <tr v-for="row in embroidery_order.order_initials" :key="row.id">
                            <td>{{ row.quantity }}</td>
                            <td>{{ row.position }}</td>
                            <td>{{ row.num_stitches}}</td>
                            <td >{{ row.quantity * row.num_stitches }}</td>
                            <td >{{ row.firstname}} {{ row.surname}}</td>
                            <td>{{  row.updated_at_date }}</td>
                        </tr>

                    </table>
                    <div class="notification is-warning" v-if="this.embroidery_order.orderID > 0 && this.loading_embroidery == false && embroidery_order.order_initials.length == 0">
                        There are no initials linked to this order yet
                    </div>

                </div>

                <div class="card-content" v-if="tabToShow == 'extras'">
                    
                    <div class="field">
                        <label class="label">Knitted Trims</label>
                        <div class="control ">
                            <div v-if="this.order.requires_knitted_trim == 1">
                                <button class="button is-success is-small" @click="updateKnittedTrim(order, 0)" :disabled="working==true">Selected</button><br />
                                <small><em>Click the button to turn off</em></small>
                            </div>
                            <div v-if="this.order.requires_knitted_trim == 0">
                                <button class="button is-danger is-small" @click="updateKnittedTrim(order, 1)" :disabled="working==true">Not Selected</button><br />
                                <small><em>Click the button to turn on</em></small>
                            </div>
                        </div>
                            
                    </div>
                    
                        
                </div>


            </div>

            
    </div>

    
    
    
    
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import OrderBundles from "@/components/Orders/OrderBundles.vue";
 

export default {
   
  components: {
    OrderBundles
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      order: {orderID: 0},
      embroidery_order: [{order_trex_codes: [], design_trex_codes: [], order_initials: []}],
      trex_codes: [],
      loading_embroidery: true,
      showAddButtons: false,
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading:false,
      locations: [],
      makeuplocations: [],
      ponumber: '',
      ASP_URL : process.env.VUE_APP_ASP_URL,
      tabToShow : 'general',
      sizes: [],
      user: {tasks: []},
    }
  },
   methods: {
        showAlert(alertText){
            alert(alertText)
        },
        async getOrderEmbroideryDetails() {
            this.search_done = false
            this.trex_codes = []
            if(this.order.orderID > 0)
            {
                this.loading_embroidery = true
                UtilityService.getSimpleApiData(this.accessToken, "orders/" + this.order.orderID + "?include_embroidery=1").then(
                    (response => {
                        this.$set(this, "embroidery_order", response);
                        this.loading_embroidery=false
                    
                    }).bind(this)
                    
                );
            }
        },
      async viewOrder() {
        if(this.ponumber != '' && this.ponumber != null)
        {
            this.order = []
          this.loading=true
          OrderService.getOrderByPONumber(this.accessToken, this.ponumber, "", 1) // Last one is to get all logs back
          .then(
            (orders => {
                if(orders.length > 0)
                {
                      this.$set(this, "order", orders[0]);

                      if(this.order.order_embroidery == 1)
                      {
                        this.getOrderEmbroideryDetails()
                      }
                      
                }
                else{
                    this.order = []
                }
              this.loading=false
              this.working = false
            }).bind(this)
          );
        }
      },
      focusInput() {
          this.$nextTick(() => this.$refs.ponumber.focus())
      },
      getPONumber() {
        let urlParams = new URLSearchParams(window.location.search);
        let urlPONumber = urlParams.get('ponumber');
        this.ponumber = urlPONumber

        this.viewOrder()
      },
      async completeOrder() {
        this.working = true
        
        if(confirm('Are you sure you want to complete this order ? It will be removed from all open order screens.'))
        {
            var order_id = this.order.orderID

            var formdata = { 
                _method: 'patch',
                completed: 1
            }; 

            OrderService.updateOrder(this.accessToken, order_id, formdata)
            .then(() => {
            
                this.viewOrder()
                //console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
        }
        
    },
    async updateKnittedTrim(order, newValue)
    {
      
      this.working = true
      var formdata = { 
          _method: 'patch',
          requires_knitted_trim: newValue
        }

        OrderService.updateDesign(this.accessToken, order.designID, formdata)
        .then(() => {
            this.viewOrder()
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
      
    
    
  },
  computed : {
      qty_sizes: function () {
        let order = this.order 
        let qty_sizes =  this.sizes.filter(function(u) {
            if(  (order[u.database_name] + order[u.database_name + '_GK'] ) > 0) 
            {
              return 1
            }
          })

          return qty_sizes
       
     },
     total_qty: function() {
        let order = this.order 
        const total = this.qty_sizes.reduce((sum, object) => {
            if( (order[object.database_name] + order[object.database_name + '_GK']) > 0)
            {
                sum = sum + order[object.database_name] + order[object.database_name + '_GK'];
            }

            return sum;
            
        }, 0);

        return total;
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getLocations();
           //this.getMakeupLocations(); 
           this.getSizes();

           this.focusInput()
            

           if(this.$route.params.id != "" && this.$route.params.id != undefined)
           {
             this.ponumber = this.$route.params.id
            this.viewOrder()
            
           }
           else
           {
            this.getPONumber()
           }

          
           this.getUserProfile(1); // 1 for with_tasks
        });
  },
 
  mounted() {
   
     
  },
  watch: {
    '$route'() {
      
    },
    
  }
}


</script>

